import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FileManagerSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FileManagerSVG;
